import { SET_MESSAGE } from "actions/message";

export default (state = {}, action) => {
  switch (action.type) {
    case SET_MESSAGE:
      return action.payload.message;
    default:
      return state;
  }
};
